module.exports = __webpack_public_path__ + "static/favicon-46d9cf0becf854d8e5043b83b08b9091.ico";